export default "Lær at binde et råbåndsknob - brug det fx når I skal binde jeres hjemmelavede trækbåre sammen.";